import AppModel from '@/models/AppModel'
import store from '@/store/model-store'

const isDebug = process.env.NODE_ENV !== 'production'

export default {
  apiSetStore: (bvModal, callback) => {
    return AppModel.get('direct_estimate_url_regist', bvModal, null, (res) => {
      if (isDebug) {
        console.log(res.data)
      }

      AppModel.validateStatus(res.data)

      let modelStore = store.getters.model
      if (!modelStore) {
        modelStore = {}
      }
      modelStore['directEstimateUrlRegist'] = res.data
      store.commit('setModel', modelStore)

      return Promise.resolve(res.data)
    }, null, callback)
  },
  getStore: (key) => {
    return AppModel.getStore('directEstimateUrlRegist', key)
  },
  removeStore: () => {
    delete store.getters.model.directEstimateUrlRegist
  }
}



// WEBPACK FOOTER //
// ./src/models/DirectEstimateUrlRegistModel.js